<div class="overlay-inner-wrapper">
  <div id="measurementWrapper">
    <header class="header-2" style="margin-left: -15px; margin-top: -15px; margin-right: -15px">
      <div class="branding">
        <span class="title">{{ 'Messungen' | mrTranslate }} vom {{ LPDatum }}</span>
      </div>
      <div class="header-actions">
        <a href="javascript://" class="nav-link nav-icon" aria-label="toggle settings menu" (click)="opened = true">
          <cds-icon shape="cog" [title]="'Einstellungen' | mrTranslate" />
        </a>
        <a href="javascript://" class="nav-link nav-icon">
          <cds-icon shape="times" (click)="close()" />
        </a>
      </div>
    </header>

    <div
      class="clr-form clr-form-compact clr-form-horizontal"
      style="margin-bottom: 1rem; display: flex; flex-wrap: wrap; flex-direction: column">
      <div>
        <clr-side-panel
          [(clrSidePanelOpen)]="opened"
          [clrSidePanelPreventClose]="true"
          (clrSidePanelAlternateClose)="savePanelSettings()"
          [clrSidePanelStaticBackdrop]="true">
          <h3 class="side-panel-title">{{ 'Messungsübersicht Einstellungen' | mrTranslate }}</h3>
          <div class="side-panel-body">
            <clr-stack-view [formGroup]="optGroup" style="margin-top: 5px">
              <clr-stack-block [clrSbExpanded]="true">
                <clr-stack-label>{{ 'Zustand' | mrTranslate }}</clr-stack-label>

                <clr-stack-block>
                  <clr-stack-label>{{ 'Gleismessung' | mrTranslate }}</clr-stack-label>
                  <clr-stack-content>
                    <input type="checkbox" clrCheckbox formControlName="show_Gleismessung" />
                  </clr-stack-content>
                </clr-stack-block>

                <clr-stack-block>
                  <clr-stack-label>{{ 'Profil-Viewer' | mrTranslate }}</clr-stack-label>
                  <clr-stack-content>
                    <input type="checkbox" clrCheckbox formControlName="show_ProfileViewer" />
                  </clr-stack-content>
                </clr-stack-block>

                <clr-stack-block>
                  <clr-stack-label>{{ 'Trassierung' | mrTranslate }}</clr-stack-label>
                  <clr-stack-content>
                    <input type="checkbox" clrCheckbox formControlName="show_Trassierung" />
                  </clr-stack-content>
                </clr-stack-block>

                <clr-stack-block>
                  <clr-stack-label>{{ 'GISMAP' | mrTranslate }}</clr-stack-label>
                  <clr-stack-content>
                    <input type="checkbox" clrCheckbox formControlName="show_GISMAP" />
                  </clr-stack-content>
                </clr-stack-block>

                <clr-stack-block>
                  <clr-stack-label>{{ 'Passbild' | mrTranslate }}</clr-stack-label>
                  <clr-stack-content>
                    <input type="checkbox" clrCheckbox formControlName="show_Detailview" />
                  </clr-stack-content>
                </clr-stack-block>
              </clr-stack-block>
            </clr-stack-view>
          </div>
        </clr-side-panel>
      </div>

      <div class="container">
        <div class="split-example" style="height: 95vh">
          <as-split direction="horizontal" restrictMove="true" [useTransition]="true">
            <as-split-area size="50">
              <as-split direction="vertical" restrictMove="true">
                <as-split-area size="35">
                  @if (curGraph) {
                    <div style="width: 100%">
                      <div class="clr-row" style="margin-left: 12px">
                        <div class="clr-col-2">
                          {{ 'Messtyp' | mrTranslate }}
                        </div>
                        <div class="clr-col-2">
                          <div class="clr-select-wrapper">
                            <select
                              class="clr-select"
                              #sel
                              [(ngModel)]="selectedmess"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="selectedMessChanged(sel.value)">
                              @for (item of graph.data; track item) {
                                <option [ngValue]="item['name']">
                                  {{ item['name'] | mrTranslate }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="clr-col-12">
                        <div style="height: 24vh; position: relative">
                          <div id="plotly_Sub"></div>
                        </div>
                      </div>
                    </div>
                  }
                </as-split-area>
                @if (optGroup.controls.show_GISMAP.value) {
                  <as-split-area size="40">
                    <!-- Karte -->
                    <div style="width: 100%; height: 37vh; position: relative">
                      <div style="margin-top: 10px; margin-left: 5px; position: absolute; z-index: 2">
                        <clr-dropdown>
                          <button
                            type="button"
                            class="btn btn-success dropdown-toggle"
                            action="solid"
                            clrDropdownTrigger>
                            <cds-icon shape="world" size="26" />
                            <cds-icon shape="caret" direction="down" />
                          </button>

                          <clr-dropdown-menu *clrIfOpen>
                            <a (click)="tileSwitch('sonstige', 'leer')" clrDropdownItem>{{ 'leer' | mrTranslate }}</a>

                            <clr-dropdown>
                              <button clrDropdownTrigger>Carto DB</button>
                              <clr-dropdown-menu *clrIfOpen>
                                <clr-dropdown>
                                  <a (click)="tileSwitch('cartoDB', 'cartoDbDark')" clrDropdownItem>Dark</a>
                                  <a (click)="tileSwitch('cartoDB', 'cartoDbDarkNoLabels')" clrDropdownItem>
                                    Dark no Label
                                  </a>
                                  <a (click)="tileSwitch('cartoDB', 'cartoDbLight')" clrDropdownItem>Light</a>
                                  <a (click)="tileSwitch('cartoDB', 'cartoDbLightNoLabels')" clrDropdownItem>
                                    Light no Label
                                  </a>
                                </clr-dropdown>
                              </clr-dropdown-menu>
                            </clr-dropdown>

                            <clr-dropdown>
                              <button clrDropdownTrigger>ESRI</button>
                              <clr-dropdown-menu *clrIfOpen>
                                <clr-dropdown>
                                  <a (click)="tileSwitch('sonstige', 'esri')" clrDropdownItem>Hybrid</a>
                                </clr-dropdown>
                              </clr-dropdown-menu>
                            </clr-dropdown>

                            <clr-dropdown>
                              <button clrDropdownTrigger>{{ 'Geoportale' | mrTranslate }}</button>
                              <clr-dropdown-menu *clrIfOpen>
                                <clr-dropdown>
                                  <button clrDropdownTrigger>{{ 'Belgien' | mrTranslate }}</button>
                                  <clr-dropdown-menu *clrIfOpen>
                                    <clr-dropdown>
                                      <a (click)="tileSwitch('sonstige', 'belgiumOrtho')" clrDropdownItem>Ortho</a>
                                      <a (click)="tileSwitch('sonstige', 'belgiumCarto')" clrDropdownItem>Carto.be</a>
                                    </clr-dropdown>
                                  </clr-dropdown-menu>
                                </clr-dropdown>

                                <clr-dropdown>
                                  <button clrDropdownTrigger>{{ 'Deutschland' | mrTranslate }}</button>
                                  <clr-dropdown-menu *clrIfOpen>
                                    <clr-dropdown>
                                      <a (click)="tileSwitch('sonstige', 'bb_house')" clrDropdownItem>
                                        {{ 'BB ALKIS Gebäude' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'bb_lands')" clrDropdownItem>
                                        {{ 'BB ALKIS Flurstücke' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'bb_ortho')" clrDropdownItem>BB Ortho</a>
                                      <a (click)="tileSwitch('sonstige', 'he_ortho')" clrDropdownItem>HE Ortho</a>
                                      <a (click)="tileSwitch('sonstige', 'mv_house')" clrDropdownItem>
                                        {{ 'MV ALKIS Gebäude' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'mv_lands')" clrDropdownItem>
                                        {{ 'MV ALKIS Flurstücke' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'mv_ortho')" clrDropdownItem>MV Ortho</a>

                                      <a (click)="tileSwitch('sonstige', 'ni_ortho')" clrDropdownItem>NI Ortho</a>
                                      <a (click)="tileSwitch('sonstige', 'nrw_house')" clrDropdownItem>
                                        {{ 'NR ALKIS Gebäude' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'nrw_lands')" clrDropdownItem>
                                        {{ 'NR ALKIS Flurstücke' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'nrwOrtho')" clrDropdownItem>NR Ortho</a>
                                      <a (click)="tileSwitch('sonstige', 'sa_ortho')" clrDropdownItem>SA Ortho</a>
                                      <a (click)="tileSwitch('sonstige', 'sn_house')" clrDropdownItem>
                                        {{ 'SN ALKIS Gebäude' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'sn_lands')" clrDropdownItem>
                                        {{ 'SN ALKIS Flurstücke' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'sn_ortho')" clrDropdownItem>SN Ortho</a>
                                      <a (click)="tileSwitch('sonstige', 'th_ortho')" clrDropdownItem>TH Ortho</a>

                                      <a (click)="tileSwitch('sonstige', 'de_farbe')" clrDropdownItem>BASEMAP.DE</a>
                                      <a (click)="tileSwitch('sonstige', 'de_grau')" clrDropdownItem>BASEMAP.DE grau</a>
                                    </clr-dropdown>
                                  </clr-dropdown-menu>
                                </clr-dropdown>

                                <clr-dropdown>
                                  <button clrDropdownTrigger>Luxemburg</button>
                                  <clr-dropdown-menu *clrIfOpen>
                                    <clr-dropdown>
                                      <a (click)="tileSwitch('sonstige', 'luxBaseMap')" clrDropdownItem>Basemap</a>
                                      <a (click)="tileSwitch('sonstige', 'luxOrtho')" clrDropdownItem>Ortho</a>
                                    </clr-dropdown>
                                  </clr-dropdown-menu>
                                </clr-dropdown>

                                <clr-dropdown>
                                  <button clrDropdownTrigger>{{ 'Österreich' | mrTranslate }}</button>
                                  <clr-dropdown-menu *clrIfOpen>
                                    <clr-dropdown>
                                      <a (click)="tileSwitch('sonstige', 'austriaOrtho')" clrDropdownItem>
                                        {{ 'Österreich Ortho' | mrTranslate }}
                                      </a>
                                      <!-- <a clrDropdownItem>Voralberg Ortho</a> -->
                                    </clr-dropdown>
                                  </clr-dropdown-menu>
                                </clr-dropdown>

                                <clr-dropdown>
                                  <button clrDropdownTrigger>{{ 'Schweiz' | mrTranslate }}</button>
                                  <clr-dropdown-menu *clrIfOpen>
                                    <clr-dropdown>
                                      <a (click)="tileSwitch('sonstige', 'ch_base')" clrDropdownItem>
                                        {{ 'Swisstopo Pixelkarte farbe' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'ch_base_grau')" clrDropdownItem>
                                        {{ 'Swisstopo Pixelkarte grau' | mrTranslate }}
                                      </a>
                                      <a (click)="tileSwitch('sonstige', 'ch_ortho')" clrDropdownItem>
                                        Swisstopo Ortho
                                      </a>
                                    </clr-dropdown>
                                  </clr-dropdown-menu>
                                </clr-dropdown>
                              </clr-dropdown-menu>
                            </clr-dropdown>

                            <clr-dropdown>
                              <button clrDropdownTrigger>Google</button>
                              <clr-dropdown-menu *clrIfOpen>
                                <clr-dropdown>
                                  <a (click)="tileSwitch('google', 'googleMaps')" clrDropdownItem>GoogleMaps</a>
                                  <a (click)="tileSwitch('google', 'googleSatellite')" clrDropdownItem>Satelit</a>
                                  <a (click)="tileSwitch('google', 'googleHybrid')" clrDropdownItem>Hybrid</a>
                                  <a (click)="tileSwitch('google', 'googleTerrain')" clrDropdownItem>Terrain</a>
                                </clr-dropdown>
                              </clr-dropdown-menu>
                            </clr-dropdown>

                            <clr-dropdown>
                              <button clrDropdownTrigger>Openstreetmap</button>
                              <clr-dropdown-menu *clrIfOpen>
                                <clr-dropdown>
                                  <a (click)="tileSwitch('sonstige', 'osmde')" clrDropdownItem>Openstreetmap</a>
                                </clr-dropdown>
                              </clr-dropdown-menu>
                            </clr-dropdown>

                            <a (click)="tileSwitch('sonstige', 'wikimedia')" clrDropdownItem>WikiMaps</a>
                          </clr-dropdown-menu>
                        </clr-dropdown>
                      </div>
                      <div id="previewMap" style="width: 100%; height: 100%; z-index: 1"></div>
                    </div>
                  </as-split-area>
                }

                @if (optGroup.controls.show_Trassierung.value) {
                  <as-split-area size="25">
                    <div class="clr-row" style="margin-left: 12px">
                      <div class="clr-col-2">
                        {{ 'Trassierungselement' | mrTranslate }}
                      </div>
                      <div class="clr-col-2">
                        <div class="clr-select-wrapper">
                          <select
                            class="clr-select"
                            #sel
                            [(ngModel)]="selectedtyp"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="selectedTrassChanged(sel.value)">
                            @for (item of typen; track item) {
                              <option [ngValue]="item['Id']">
                                {{ item['Bezeichnung'] | mrTranslate }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    </div>

                    @if (graphTrass.length > 0) {
                      <div class="height:24vh; position: relative;">
                        <app-plotly-plot
                          [className]=""
                          [data]="graphTrass"
                          [layout]="layout"
                          [config]="graphconfig"></app-plotly-plot>
                      </div>
                    }
                  </as-split-area>
                }
              </as-split>
            </as-split-area>
            <as-split-area size="40">
              <as-split direction="vertical" restrictMove="true">
                @if (optGroup.controls.show_ProfileViewer.value) {
                  <as-split-area size="60">
                    <div class="clr-row">
                      <div>
                        @if (isLoading) {
                          <clr-spinner class="centred"></clr-spinner>
                        }

                        <div class="card-block" style="width: 99%; padding-top: 0px">
                          <div class="clr-row clr-justify-content-between" style="margin-top: 0px">
                            <div id="plotly_Left" class="clr-col-6"></div>
                            <div id="plotly_Right" class="clr-col-6"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="clr-row nxm mt-10 custom-slider">
                      <ngx-slider [(value)]="ind" [options]="slideroptions"></ngx-slider>
                    </div>
                  </as-split-area>
                }
                @if (optGroup.controls.show_Detailview.value) {
                  <as-split-area size="60">
                    <div style="height: 100%; width: 85%">
                      <app-image-slide-show [data]="files$" />
                    </div>
                  </as-split-area>
                }
              </as-split>
            </as-split-area>
          </as-split>
        </div>
      </div>
    </div>
  </div>
</div>
